import React, { PropTypes } from 'react'
import PreviousWebinarItem from './PreviousWebinarItem'
import SelectField from 'components/InputField/SelectField';

const PreviousWebinars = ({
    webinars,
    nextPage,
    pagination,
    count,
    sponsor,
    sponsors,
    onFilterChange
  }) => (
  <div>
    <div id="previous" className="section_previous_title">
      RECORDED WEBINARS {count ? `(${count})` : '(0)'}
    </div>

    {webinars.length &&
      <div className="section_webinars_sponsors_filter">
        <SelectField
          value={sponsor}
          options={sponsors}
          field_name="sponsor"
          label={'Filter by sponsors'}
          onChange={onFilterChange}
        />
      </div>
    }

    <div className="container_previous">
      {webinars}
      {pagination && <a className="more_item" href="javascript:void(0)" onClick={nextPage}>LOAD MORE</a>}
    </div>
  </div>
)

PreviousWebinars.propTypes = {
  webinar: PropTypes.obj,
  onFilterChange: PropTypes.func,
}

export default PreviousWebinars



/** WEBPACK FOOTER **
 ** ./src/components/Dashboard/PreviousWebinars/PreviousWebinars.js
 **/